import script from "./SwiftDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SwiftDataTable.vue?vue&type=script&setup=true&lang=js"

import "./SwiftDataTable.vue?vue&type=style&index=0&id=084a73a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-084a73a4"]])

export default __exports__